import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Trans } from 'lingui-react';
import Sticky from 'react-sticky-fill';
import AssetDisplayContainer from 'containers/AssetDisplayContainer';

import { ListTable } from 'base-components';

import { shouldBuildLoadingGhosts } from 'utils/favorites';

import ListRowLoading from 'components/_common/ListRowLoading';

import messages from './messages';

const MAX_LOADING_ROWS = 10;

function renderAssetList(assets) {
  return assets.map((assetInfo) => {
    const assetId = assetInfo.get('id');
    return (
      <AssetDisplayContainer datum={assetInfo} key={assetId} type="list" />
    );
  });
}

function renderGhostRows(assets, favoritePagination, requesting) {
  if (
    !shouldBuildLoadingGhosts({
      currentCount: assets.size,
      favoritePagination,
      requesting,
    })
  ) {
    return null;
  }
  const totalCount = favoritePagination.get('totalCount');
  const count = totalCount
    ? Math.min(MAX_LOADING_ROWS, totalCount - assets.size)
    : MAX_LOADING_ROWS;
  return Array.from({ length: count }, (_, i) => (
    <ListRowLoading key={i} columnSpans={[1, 3, 2, 4, 2]} />
  ));
}

function AssetsListView({ assets, favoritePagination, requesting }) {
  return (
    <ListTable>
      <Sticky style={{ top: '80px' }}>
        <ListTable.Head>
          <ListTable.Header>
            <Trans id={messages.unitNumber} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.serial} />
          </ListTable.Header>
          <ListTable.Header flex={1.5} minWidth={150}>
            <Trans id={messages.vin} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.make} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.model} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.year} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.engine} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.odometer} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.pmStatus} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.other} />
          </ListTable.Header>
        </ListTable.Head>
      </Sticky>
      <ListTable.Body>
        {renderAssetList(assets)}
        {renderGhostRows(assets, favoritePagination, requesting)}
      </ListTable.Body>
    </ListTable>
  );
}

AssetsListView.propTypes = {
  assets: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      id: PropTypes.string,
    }),
  ).isRequired,
  favoritePagination: ImmutablePropTypes.map.isRequired,
  requesting: PropTypes.bool.isRequired,
};

AssetsListView.defaultProps = {
  favoritePagination: Map(),
  requesting: false,
};

export default AssetsListView;



// WEBPACK FOOTER //
// ./components/AssetsPanel/AssetsListView.js